import { CmsComponent, CmsParagraphComponent } from "@spartacus/core";

export interface UigCMSQuestionnaireFormComponent extends CmsParagraphComponent {
    formUniqueName?: string,
    formObserverEmail?: string
}

export class UigQuestionnaireHtmlElement {

    content: string;

    constructor(content: string) {
        this.content = content;
    }

}

export class UigQuestionnaireElementType {
    elementName = "";
    newInstance: () => UigQuestionnaireBaseElement;

    constructor(elementName: string, newInstance: () => UigQuestionnaireBaseElement) {
        this.elementName = elementName;
        this.newInstance = newInstance;
    }
}

export class UigQuestionnaireBaseElement {
    static elementName = "";
    static newInstance: () => UigQuestionnaireBaseElement;
    name = "";
    id = "";
    value = "";
    style = "";
    class = "";
}

export class UigQuestionnaireInputElement extends UigQuestionnaireBaseElement {
    static elementName = "input";
    static newInstance = (): UigQuestionnaireBaseElement => {
        return new UigQuestionnaireInputElement();
    };
    
    type = "";
    readonly = "";
    multiple = "";
    size = "";
    maxlength = "";
    min = "";
    max = "";
    pattern = "";
    placeholder = "";
    required = "";
    step = "";
    autofocus = "";
    list = "";
    autocomplete = "";
    checked = "";

}

export class UigQuestionnaireTextareaElement extends UigQuestionnaireBaseElement {
    static elementName = "textarea";
    static newInstance = (): UigQuestionnaireBaseElement => {
        return new UigQuestionnaireTextareaElement();
    };

    rows = "";
    cols = "";
    required = "";
    readonly = "";
    innerHTML = "";
}

export class UigQuestionnaireSelectElement extends UigQuestionnaireBaseElement {
    static elementName = "select";
    static newInstance = (): UigQuestionnaireBaseElement => {
        return new UigQuestionnaireSelectElement();
    };

    required = "";
    readonly = "";
    multiple = "";
    size="";
    options : UigQuestionnaireOptionElement[] = [];
}

export class UigQuestionnaireOptionElement extends UigQuestionnaireBaseElement {
    static elementName = "option";
    static newInstance = (): UigQuestionnaireBaseElement => {
        return new UigQuestionnaireOptionElement();
    };

    disabled = "";
    selected = "";
    value="";
    innerHTML ="";
}